module.exports = __webpack_public_path__ + "img/workImg.de7a1fce.png";